/*
 * logErrors.ts
 *
 * Created by Dr. Maximillian Dornseif 2023-11-08 in huWaWi3 33.6.0
 * Copyright (c) 2023 HUDORA GmbH
 */
import { captureException } from '@sentry/browser';

export async function hdErrorToSentry(error): void {
  console.log(typeof error, error);
  // https://getsentry.github.io/sentry-javascript/functions/_sentry_browser.captureMessage.html
  // "error"

  // captureException
  captureException(error);
  // setUser, setTag, setExtras, addBreadcrumb
}
